module.exports = __webpack_public_path__ + "img/firefox.e1f2da10.svg";